import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { CardHeader, CardBody, CardFooter } from 'shards-react';

import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import TableWithPagination from '../../../components/common/Table/TableWithPagination';
import { usePayments } from '../../../hooks/queries/usePayments';
import DateInput from '../../../components/inputs/DateInput';
import PaymentOrderInput from '../../../components/inputs/PaymentOrderInput';

const paymentsPerPage = 10;
const inputs = [DateInput, PaymentOrderInput];
const headers = [
  {
    value: 'paymentDate',
    label: 'Fecha de Pago',
    hasLink: true,
    redirect: '/admin/payments/$'
  },
  {
    value: 'clearingNumber',
    label: 'Numero de Liquidación',
    hasLink: true,
    redirect: '/admin/payments/$'
  },
  {
    value: 'totalAmount',
    label: 'Total Presentado',
    hasLink: true,
    redirect: '/admin/payments/$'
  },
  {
    value: 'totalDeduction',
    label: 'Total Deducido',
    hasLink: true,
    redirect: '/admin/payments/$'
  },
  {
    value: 'totalEarn',
    label: 'Total Acreditado',
    hasLink: true,
    redirect: '/admin/payments/$'
  },
  {
    value: 'totalEarn',
    label: 'Total Acreditado',
    hasLink: true,
    redirect: '/admin/payments/$'
  }
];

const ShowPayments = ({ establishmentNumber }) => {
  const [searchFilter, setSearchFilter] = useState({});
  const [offset, setOffset] = useState(0);
  const filter = useMemo(() => {
    const { date, ...rest } = searchFilter;
    return {
      ...rest,
      establishmentNumber,
      paymentDate: date
    };
  }, [establishmentNumber, searchFilter]);

  const { payments } = usePayments(filter, { limit: paymentsPerPage, offset });

  const onSubmit = (newFilter) => {
    setSearchFilter(newFilter);
    setOffset(0);
  };

  const handlePageClick = (direction) => {
    const newOffset = offset + direction * paymentsPerPage;
    if (newOffset >= 0) setOffset(newOffset);
  };

  return (
    <>
      <CardHeader className="border-bottom">
        <h6 className="m-0">Liquidaciones</h6>
      </CardHeader>
      <CardBody>
        <GenericSearchBar handleSubmit={onSubmit} inputs={inputs} />
        <TableWithPagination
          data={payments}
          disableNext={payments.length < paymentsPerPage}
          disablePrev={offset === 0}
          handlePageClick={handlePageClick}
          headers={headers}
        />
      </CardBody>
      <CardFooter />
    </>
  );
};

ShowPayments.propTypes = {
  establishmentNumber: PropTypes.string
};

export default ShowPayments;
